import { useReducer } from "react";
import { IoWaterOutline } from "react-icons/io5";
import { IoWaterSharp } from "react-icons/io5";
import { GrPowerReset } from "react-icons/gr";
import Artwork from "./Artwork";

const countFromLocalStorage = JSON.parse(localStorage.getItem("drinkCount") || 0);

const ACTIONS = {
    INCREMENT: "increase",
    DECREMENT: "decrease",
    RESET: "reset",
};

const initialState = { count: countFromLocalStorage };

function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.INCREMENT:
            return state.count < 8 ? { count: state.count + 1 } : state;

        case ACTIONS.DECREMENT:
            return state.count > 0 ? { count: state.count - 1 } : state;

        case ACTIONS.RESET:
            return { count: (state.count = 0) };
        default:
            return state;
    }
}

function Counter() {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <div className="flex flex-col justify-between  min-h-screen sm:gap-5">
            <Artwork count={state.count} />

            <div className="flex flex-col sm:flex-row justify-center items-center ">
                <div className="flex flex-col items-center p-1 sm:p-10 text-center cursor-default ">
                    {state.count >= 8 ? (
                        <div className="text-3xl  sm:text-6xl font-bold px-3 pt-1 pb-1 text-white  bg-black animate-fade-in">
                            <p className="font-light">Great!</p>
                            <p>{state.count} Glasses</p>
                        </div>
                    ) : (
                        <div className="  text-3xl sm:text-2xl w-36 px-3  pb-1 text-black   ">
                            <span className="font-bold text-6xl   sm:text-8xl 2xl:text-9xl animate-fade-in">{state.count}</span>
                            <br />
                            {state.count === 1 ? (
                                <p className=" text-white p-1   font-light uppercase tracking-wider text-sm  border-2 bg-black border-black    ">glass</p>
                            ) : (
                                <p className=" text-white p-1  font-light uppercase tracking-wider text-sm  border-2 bg-black border-black    ">glasses</p>
                            )}
                        </div>
                    )}
                </div>

                <div className="flex   gap-5 p-4 justify-center  font-normal">
                    {state.count < 8 && (
                        <button
                            className="bg-white shadow-lg p-5  rounded-full h-16 sm:h-20 w-16 sm:w-20 flex items-center justify-center transform hover:scale-105 transition duration-500 ease-in-out hover:shadow-2xl"
                            onClick={() => dispatch({ type: ACTIONS.INCREMENT })}
                        >
                            <div className="text-2xl sm:text-4xl ">
                                <IoWaterSharp />
                            </div>

                            <div>+</div>
                        </button>
                    )}

                    {state.count < 8 ? (
                        <button
                            className="bg-white p-5 shadow-lg rounded-full h-16 sm:h-20 w-16 sm:w-20 flex items-center justify-center transform hover:scale-105 transition duration-500 ease-in-out hover:shadow-2xl "
                            onClick={() => dispatch({ type: ACTIONS.RESET })}
                        >
                            <div className="text-2xl sm:text-4xl ">
                                <GrPowerReset />
                            </div>
                        </button>
                    ) : (
                        <button
                            className="bg-white p-5 shadow-lg rounded-full h-16 sm:h-20 w-16 sm:w-20 flex items-center justify-center transform hover:scale-105 transition duration-500 ease-in-out hover:shadow-2xl "
                            onClick={() => dispatch({ type: ACTIONS.RESET })}
                        >
                            <div className="text-2xl sm:text-4xl ">
                                <GrPowerReset />
                            </div>
                        </button>
                    )}

                    {state.count < 8 && (
                        <button
                            className="bg-white p-5 shadow-lg rounded-full h-16 sm:h-20 w-16 sm:w-20 flex items-center justify-center transform hover:scale-105 transition duration-500 ease-in-out  hover:shadow-2xl "
                            onClick={() => dispatch({ type: ACTIONS.DECREMENT })}
                        >
                            <div className="text-2xl sm:text-4xl  ">
                                <IoWaterOutline />
                            </div>
                            <div>-</div>
                        </button>
                    )}
                </div>
            </div>

            <div className="flex justify-center flex-col items-center floor gap-10 p-11 sm:p-20  "></div>
        </div>
    );
}

export default Counter;
